document.addEventListener("DOMContentLoaded", async function () {
  const REMOVE_ICON_SVG = `<svg class="removeItem-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path></svg>`;
  const REMOVE_BUTTON_LABEL = `${REMOVE_ICON_SVG}<span class="removeItem-label">Remove</span>`;

  /**
   * Formats a price for Shopify
   *
   * @param {number|string} priceInput
   *
   * @return {string}
   */
  function formatPriceShopify(priceInput) {
    const price =
      typeof priceInput === "number" ? priceInput : Number(priceInput);

    const currency = window.Shopify.currency.active || "EUR";
    const language = (window.Shopify.locale || "en").split("-")[0];
    const country = window.Shopify.country || "DE";

    // Round to whole numbers for non-EUR/GBP currencies
    const fractionDigits = ["EUR", "GBP"].includes(currency) ? 2 : 0;

    // Format the price using Intl.NumberFormat
    const formatted = new Intl.NumberFormat(`${language}-${country}`, {
      style: "decimal",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price);

    // For NOK currency, return in format "XX kr"
    if (currency === "NOK") {
      return `${formatted} kr.`;
    }

    // For other currencies, always prefix the currency symbol (e.g. €12,34)
    const parts = new Intl.NumberFormat(`${language}-${country}`, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).formatToParts(price);

    const symbol =
      parts.find((part) => part.type === "currency")?.value || "";
    const amount = parts
      .filter((part) => part.type !== "currency")
      .map((part) => part.value)
      .join("")
      .trim();

    return `${symbol}${amount}`;
  }

  const bonusBadgeHtml = `
    <span class="slidecart-bonus-badge">
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M10.8333 6.5V11.9167H2.16665V6.5" stroke="#009477" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.9167 3.79166H1.08335V6.5H11.9167V3.79166Z" stroke="#009477" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.5 11.9167V3.79166" stroke="#009477" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.50002 3.79167H4.06252C3.70337 3.79167 3.35893 3.649 3.10498 3.39505C2.85102 3.14109 2.70835 2.79665 2.70835 2.4375C2.70835 2.07836 2.85102 1.73392 3.10498 1.47996C3.35893 1.22601 3.70337 1.08334 4.06252 1.08334C5.95835 1.08334 6.50002 3.79167 6.50002 3.79167Z" stroke="#009477" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.5 3.79167H8.9375C9.29665 3.79167 9.64109 3.649 9.89504 3.39505C10.149 3.14109 10.2917 2.79665 10.2917 2.4375C10.2917 2.07836 10.149 1.73392 9.89504 1.47996C9.64109 1.22601 9.29665 1.08334 8.9375 1.08334C7.04167 1.08334 6.5 3.79167 6.5 3.79167Z" stroke="#009477" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Bonus Item
    </span>
  `;

  function getFreeShippingThreshold() {
    const currentCountry = window.Shopify.country || "DE";
    const activeCurrency = window.Shopify.currency.active || "EUR";
    const thresholds = window.FREE_SHIPPING_THRESHOLDS || {
      default: { amount: 33, currency: "EUR" },
    };

    const countryThreshold = thresholds[currentCountry];
    if (countryThreshold && countryThreshold.currency === activeCurrency) {
      return countryThreshold.amount;
    }

    const defaultThreshold = thresholds.default.amount;
    return convertEurToActiveCurrency(defaultThreshold);
  }

  function convertEurToActiveCurrency(eurAmount) {
    const activeCurrency = window.Shopify.currency.active || "EUR";
    console.log("activeCurrency :", window.Shopify.currency.active);
    if (activeCurrency === "EUR") {
      return eurAmount;
    }

    const currencyRate = window.Shopify.currency.rate || 1;
    return eurAmount * currencyRate;
  }
  // Helper function to get bonus items for a specific bundle
  function getBonusItemsForBundle(cart, bundleId) {
    return cart.items.filter(
      (item) => item.properties && item.properties._bundle_bonus_id === bundleId
    );
  }

  /**
   * Validates cart bundle integrity by ensuring every item with a bundle_id
   * has a corresponding bundle parent in the cart
   * @param {Object} cart - The cart object from Shopify
   * @returns {Promise<boolean>} - Returns true if validation passes, false if items were removed
   */
  async function validateCartBundleIntegrity(cart) {
    console.log("🔍 Validating cart bundle integrity...");

    // Get all bundle IDs that have bundle parents
    const bundleParents = new Set();
    cart.items.forEach((item) => {
      if (
        item.properties &&
        item.properties._bundle_id &&
        item.properties._bundle_parent === true
      ) {
        bundleParents.add(item.properties._bundle_id);
      }
    });

    console.log("📦 Found bundle parents for IDs:", Array.from(bundleParents));

    // Find orphaned bundle items (items with bundle_id but no parent)
    const orphanedItems = [];
    cart.items.forEach((item) => {
      if (
        item.properties &&
        item.properties._bundle_id &&
        item.properties._bundle_parent !== true &&
        !bundleParents.has(item.properties._bundle_id)
      ) {
        orphanedItems.push({
          key: item.key,
          bundleId: item.properties._bundle_id,
          title: item.title,
        });
      }
    });

    const hasPaidItem = cart.items.some((item) => item.line_price > 0);
    const orphanedGifts = hasPaidItem
      ? []
      : cart.items
          .filter(
            (item) =>
              item.properties && item.properties._is_free_gift === "true"
          )
          .map((item) => ({
            key: item.key,
            bundleId: item.properties._bundle_id || "n/a",
            title: item.title,
          }));

    const seenKeys = new Set();
    const itemsToRemove = [...orphanedItems, ...orphanedGifts].filter((item) => {
      if (seenKeys.has(item.key)) return false;
      seenKeys.add(item.key);
      return true;
    });

    if (itemsToRemove.length === 0) {
      console.log(
        "✅ Cart bundle integrity validated - no orphaned items found"
      );
      return true;
    }

    console.warn("⚠️ Found orphaned items:", itemsToRemove);

    // Remove orphaned items from cart
    const removePromises = itemsToRemove.map((item) => {
      console.log(
        `🗑️ Removing orphaned item: ${item.title} (Bundle ID: ${item.bundleId})`
      );
      return fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      });
    });

    try {
      await Promise.all(removePromises);
      console.log("✅ Successfully removed all orphaned bundle items");
      return false; // Items were removed, cart was modified
    } catch (error) {
      console.error("❌ Error removing orphaned bundle items:", error);
      return true; // Continue with rendering even if removal failed
    }
  }

  // Note: Bonus item removal is now handled directly in updateItemQuantity function

  let isRenderingCart = false;

  /**
   * Hides all payment buttons except Shop Pay
   */
  function hideNonShopPayButtons() {
    console.log("🔍 [Shop Pay] Starting to hide non-Shop Pay buttons...");

    const container = document.querySelector(
      "#slidecart-additional-checkout-buttons"
    );

    if (!container) {
      console.log("⚠️ [Shop Pay] Container not found");
      return;
    }

    // Hide Google Pay button directly
    // const googlePayButton = container.querySelector(
    //   "shopify-google-pay-button"
    // );
    // if (googlePayButton) {
    //   googlePayButton.style.setProperty("display", "none", "important");
    //   googlePayButton.style.setProperty("visibility", "hidden", "important");
    //   googlePayButton.style.setProperty("opacity", "0", "important");
    //   googlePayButton.setAttribute("hidden", "");
    //   console.log("✅ [Shop Pay] Hidden Google Pay button");
    // }

    // Hide buyer consent text
    const consentText = container.querySelector("#shopify-buyer-consent");
    if (consentText) {
      consentText.style.setProperty("display", "none", "important");
      console.log("✅ [Shop Pay] Hidden buyer consent text");
    }

    // Also try the alternative selector for consent
    const consentTextAlt = document.querySelector(".shopify-buyer-consent");
    if (consentTextAlt) {
      consentTextAlt.style.setProperty("display", "none", "important");
    }

    // // Ensure Shop Pay button is visible and matches checkout button size
    // const shopPayButton = container.querySelector("shop-pay-wallet-button");
    // if (shopPayButton) {
    //   shopPayButton.style.setProperty("display", "block", "important");
    //   shopPayButton.style.setProperty("width", "205%", "important");
    //   shopPayButton.style.setProperty("height", "50px", "important");
    //   shopPayButton.style.removeProperty("hidden");

    //   // Set CSS custom properties for web component
    //   shopPayButton.style.setProperty(
    //     "--shopify-accelerated-checkout-button-block-size",
    //     "50px",
    //     "important"
    //   );
    //   shopPayButton.style.setProperty(
    //     "--shopify-accelerated-checkout-button-inline-size",
    //     "50px",
    //     "important"
    //   );
    //   shopPayButton.style.setProperty(
    //     "--shopify-accelerated-checkout-button-border-radius",
    //     "8px",
    //     "important"
    //   );

    //   console.log("✅ [Shop Pay] Shop Pay button is visible and styled");
    // }

    console.log("✅ [Shop Pay] Finished hiding non-Shop Pay buttons");
  }

  window.lsgRenderCart = function () {
    renderCart();
  };
  async function renderCart() {
    if (isRenderingCart) return;
    isRenderingCart = true;

    try {
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await cartResponse.json();
      console.log("cart", cart);

      const isValid = await validateCartBundleIntegrity(cart);

      if (!isValid) {
        console.log("🔄 Cart was modified during validation, re-rendering...");
        isRenderingCart = false;
        renderCart();
        return;
      }

      clearCartDrawer();
      const obscuredCartData = obscureCartData(cart);

      const isEmpty = cart.items.length === 0;
      const $emptyMessage = $("[data-slidecart-empty-message]");
      const $cartFooter = $(".cart-footer");
      const $shippingBar = $(".slidecart-shipping-bar");

      if (isEmpty) {
        $emptyMessage.removeClass("hidden");
        $cartFooter.addClass("hidden");
        $shippingBar.addClass("hidden");
        $("[data-slidecart-order-summary]").addClass("hidden");
      } else {
        $emptyMessage.addClass("hidden");
        $cartFooter.removeClass("hidden");
        $shippingBar.removeClass("hidden");
        $("[data-slidecart-order-summary]").removeClass("hidden");
      }

      updateQuantityElements(obscuredCartData);

      const hasSubscription = cart.items.some(
        (item) => item?.selling_plan_allocation?.selling_plan
      );

      $(`[shipping-bar-percent]`).css("max-width", "0%");
      const freeShipText = $(`[slidecart-shipping-bar]`).attr(
        "free-shipping-text"
      );

      const cartTotal = cart.items_subtotal_price / 100;
      const checkoutButton = document.querySelector(".slidecart-checkout-button");
      if (checkoutButton) {
        if (cartTotal <= 0) {
          checkoutButton.disabled = true;
          checkoutButton.style.opacity = "0.5";
          checkoutButton.style.cursor = "not-allowed";
          checkoutButton.onclick = function (e) {
            e.preventDefault();
            return false;
          };
        } else {
          checkoutButton.disabled = false;
          checkoutButton.style.opacity = "1";
          checkoutButton.style.cursor = "pointer";
          checkoutButton.onclick = async function () {
            try {
              const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
              const cart = await cartResponse.json();
              await validateCartBundleIntegrity(cart);
              window.location.href = "/checkout";
            } catch (error) {
              console.error("Cart validation failed:", error);
              window.location.href = "/checkout";
            }
          };
        }
      }

      $("[shipping-notice]").each(function () {
        var text = $(this).text();
        if (text.includes("{{ price }}")) {
          text = text.replace(
            "{{ price }}",
            `${formatPriceShopify(freeShippingThreshold)}`
          );
          $(this).text(text);
        }
      });

      const freeShippingThreshold = getFreeShippingThreshold();
      //alert("freeShippingThreshold-->", freeShippingThreshold)
      console.log(
        "freeShippingThreshold: ",
        freeShippingThreshold,
        "for country:",
        window.Shopify.country
      );

      var amountToShipping = (
        freeShippingThreshold -
        parseFloat(cart.items_subtotal_price / 100).toFixed(2)
      ).toFixed(2);


      if (amountToShipping <= 0) {
        $(`[shipping-bar-percent]`).css("max-width", "100%");
        $("[data-slidecart-shipping-row]").removeClass("hidden");
        const freeShipTextHtml = `${freeShipText}`.replace(
          /free/i,
          (match) => `<span class="free-ship-highlight">${match}</span>`
        );
        $(`[shipping-progress-text]`).html(freeShipTextHtml);
        $("[shipping-notice]").each(function () {
          var text = $(this).attr("shipping-text");
          if (text.includes("{{ amount }}")) {
            $(this).html(freeShipTextHtml);
          }
        });
        $(".shipping-info-amount-pre-threshold").addClass("hidden");
        $(".shipping-info-amount-post-threshold").removeClass("hidden");
      } else if (
        parseInt(amountToShipping) == parseInt(freeShippingThreshold) &&
        cart.items.length === 0
      ) {
        $("[slidecart-product-wrapper]").html("");
        $("[data-slidecart-shipping-row]").addClass("hidden");
        $("[shipping-notice]").each(function () {
          var text = $(this).attr("shipping-text");
          if (text.includes("{{ amount }}")) {
            text = "Your cart is empty";
            $(this).text(text);
          }
        });
        $(".shipping-info-amount-pre-threshold").removeClass("hidden");
        $(".shipping-info-amount-post-threshold").addClass("hidden");
      } else {
        $("[data-slidecart-shipping-row]").addClass("hidden");
        $(`[shipping-progress-text]`).html(
          `Spend ${formatPriceShopify(amountToShipping)} more for free shipping!`
        );
        $("[shipping-notice]").each(function () {
          var text = $(this).attr("shipping-text");
          if (text.includes("{{ amount }}")) {
            text = text.replace(
              "{{ amount }}",
              `${formatPriceShopify(amountToShipping)}`
            );
            $(this).text(text);
          }
        });
        $(`[shipping-label]`).html("");
        var maxWidth =
          (parseFloat(cart.items_subtotal_price / 100).toFixed(1) /
            freeShippingThreshold) *
          100;
        $(`[shipping-bar-percent]`).css("max-width", maxWidth + "%");
        $(".shipping-info-amount-pre-threshold").removeClass("hidden");
        $(".shipping-info-amount-post-threshold").addClass("hidden");
      }

      let originalTotal = 0;
      const renderPromises = [];

      obscuredCartData.forEach((item, index) => {
        if (item.isBundleChild) return;

        const productTitle = `<h2>${item.itemTitle}</h2>`;
        const productHandle = item.itemHandle;
        const productId = item.itemID;
        if (item.isVariantImage != null) {
          var productImage = `<img src="${item.isVariantImage}" >`;
        } else {
          var productImage = `<img src="${item.itemImage}" >`;
        }
        const productPrice = `<p>${
          item.itemPrice === "0.00€" ||
          item.itemPrice === "0.00" ||
          parseFloat(item.itemPrice.replace("€", "")) === 0
            ? "FREE"
            : formatPriceShopify(item.itemPrice.replace("€", ""))
        }</p>`;
        const varaintId = item.selectedVid;
        const productQuantity = item.itemQuantity;
        const productUrl = item.itemUrl;
        const productKey = item.itemKey;
        const productPlanAllocation = item.itemSellingPlanAllocation;
        const productBundleID = item.itemBundleID;
        const isFreeGiftProperty = item.isFreeGiftProduct;
        const isBundleChild = item.isBundleChild;
        const isBundleParent = item.isBundleParent;
        const isBonusItem = item.isBonusItem;
        const bundleBonusId = item.bundleBonusId;
        const bundleChildKeys = item.bundleChildKeys;
        const bundleChildQuantities = item.bundleChildQuantities;
        const bundleItemList = item.bundleItemList;
        const bundleParentKey = item.bundleParentKey;

        const productCompareAtPrice = item.itemCompareAtPrice;

        const itemComparePrice = productCompareAtPrice
          ? parseFloat(productCompareAtPrice.toString().replace(/[^0-9.]/g, ""))
          : 0;
        const itemRegularPrice = parseFloat(
          item.itemPrice.replace(/[^0-9.]/g, "")
        );
        const itemOriginalPrice =
          itemComparePrice > 0 ? itemComparePrice : itemRegularPrice;
        originalTotal += itemOriginalPrice * productQuantity;

        console.log(
          "Item:", item.itemTitle,
          "Compare Price:", productCompareAtPrice,
          "Regular Price:", item.itemPrice,
          "Quantity:", productQuantity,
          "Item Original Price:", itemOriginalPrice,
          "_bundleFreePrice:", item._bundleFreePrice
        );

        const renderPromise = new Promise((resolve, reject) => {
          let sellingPlans,
            sellingPlanId,
            planType,
            toggleButtonClass,
            subscribeDropdownClass,
            sellingPlanGroup,
            percentOff;

          jQuery
            .getJSON(
              window.Shopify.routes.root + `products/${productHandle}.js`
            )
            .done((product) => {
              if (productPlanAllocation) {
                sellingPlanId = item.itemPlanId;
                planType = item.itemPlanType;
                toggleButtonClass = "hidden";
                subscribeDropdownClass = "";
                if (product.selling_plan_groups.length > 0) {
                  sellingPlans = product.selling_plan_groups[0].selling_plans;
                }
              } else {
                // if (product.selling_plan_groups.length > 0) {

                //   sellingPlans = product.selling_plan_groups[0].selling_plans;
                //   sellingPlanId =
                //     product.selling_plan_groups[0].selling_plans[0].id;
                //   sellingPlanGroup = product.selling_plan_groups[0].name;
                //   percentOff = sellingPlanGroup.substring(
                //     sellingPlanGroup.indexOf("(") + 1,
                //     sellingPlanGroup.lastIndexOf(")")
                //   );
                //   toggleButtonClass = "";
                //   subscribeDropdownClass = "hidden";
                // } else {
                //   toggleButtonClass = "hidden";
                //   subscribeDropdownClass = "";
                // }

                var currentVariant = product.variants.find(function (v) {
                  return v.id === varaintId;
                });

                if (
                  product.selling_plan_groups.length > 0 &&
                  currentVariant &&
                  currentVariant.selling_plan_allocations &&
                  currentVariant.selling_plan_allocations.length > 0
                ) {

                  // selling_plan_group_id this variant is actually eligible for
                  var variantPlanGroupId =
                    currentVariant.selling_plan_allocations[0].selling_plan_group_id;

                  var matchedGroup =
                    product.selling_plan_groups.find(function (g) {
                      return g.id === variantPlanGroupId;
                    }) || product.selling_plan_groups[0];

                  sellingPlans = matchedGroup.selling_plans;
                  sellingPlanId =
                    currentVariant.selling_plan_allocations[0].selling_plan_id ||
                    matchedGroup.selling_plans[0].id;
                  sellingPlanGroup = matchedGroup.name;
                  percentOff = sellingPlanGroup.substring(
                    sellingPlanGroup.indexOf("(") + 1,
                    sellingPlanGroup.lastIndexOf(")")
                  );
                  toggleButtonClass = "";
                  subscribeDropdownClass = "hidden";
                } else {
                  toggleButtonClass = "hidden";
                  subscribeDropdownClass = "";
                }
                planType = "One-time purchase";
              }

              // NEW: bonus item compare price
              let effectiveCompareAtPrice = productCompareAtPrice;
              if (isBonusItem && !effectiveCompareAtPrice) {
                const matchedVariant = product.variants.find(v => v.id === productId);
                if (matchedVariant && matchedVariant.compare_at_price) {
                  effectiveCompareAtPrice = parseFloat(matchedVariant.compare_at_price / 100)
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
                    .toString();
                }
              }

              let concatSellingPlanOptions = "";
              if (sellingPlans) {
                sellingPlans.forEach((plan) => {
                  let sellingPlanSelectAttr;
                  if (plan.id === sellingPlanId)
                    sellingPlanSelectAttr = "selected";
                  concatSellingPlanOptions = `
                    ${concatSellingPlanOptions}
                    <option value="${plan.id}"
                      product_id="${productId}"
                      qty="${productQuantity}"
                      key="${productKey}"
                      plan_id="${sellingPlanId}"
                      ${sellingPlanSelectAttr}
                    >
                      ${plan.name}
                    </option>
                  `;
                });
              }

              let discount;
              if (
                effectiveCompareAtPrice &&
                parseFloat(effectiveCompareAtPrice) > parseFloat(item.itemPrice)
              ) {
                discount =
                  Math.round(
                    ((parseFloat(effectiveCompareAtPrice) - parseFloat(item.itemPrice)) /
                      parseFloat(effectiveCompareAtPrice)) *
                      100
                  ) + "%";
              }

              const removeButtonClass =
                isBonusItem || isFreeGiftProperty ? "removeItem disabled" : "removeItem";
              const removeButtonText =
                isBonusItem || isFreeGiftProperty ? "" : REMOVE_BUTTON_LABEL;

              const showComparePrice =
                effectiveCompareAtPrice &&
                parseFloat(effectiveCompareAtPrice.toString().replace(/[^0-9.]/g, "")) >
                parseFloat(item.itemPrice.toString().replace(/[^0-9.]/g, ""));

              const concatProductInfo = `
                <div class="slidecart-item-wrapper"
                  data-slidecart-item="${productId}"
                  data-line="${Number(index + 1)}"
                  data-bundle-child-keys="${bundleChildKeys}"
                  data-bundle-child-quantities="${bundleChildQuantities}"
                  data-bundle-id="${productBundleID}"
                  data-bundle-parent-key="${bundleParentKey}"
                  data-is-bonus-item="${isBonusItem}"
                  data-bundle-bonus-id="${bundleBonusId}"
                  data-is-bundle-parent="${isBundleParent}"
                >
                  <div class="slidecart-item-image-wrapper">
                    ${
                      isBonusItem
                        ? productImage
                        : `<a href="${productUrl}">${productImage}</a>`
                    }
                  </div>
                  <div class="slidecart-item-details-wrapper">
                    <div class="slidecart-item-details-top">
                      <div class="slidecart-item-description-wrapper">
                        ${
                          isBonusItem
                            ? `<span class="slidecart-item-title slidecart-item-title--bonus">${productTitle}</span>`
                            : `<a class="slidecart-item-title" href="${productUrl}">${productTitle}</a>`
                        }
                        ${isBonusItem ? "" : bundleItemList}
                        ${
                          isBonusItem
                            ? `<span class="slidecart-item-purchase-frequency">Bonus Item</span>`
                            : ""
                        }
                      </div>
                      <div class="slidecart-item-qty-wrapper">
                        <span class="${removeButtonClass}" data-remove-key="${productKey}">${removeButtonText}</span>
                        <span class="slidecart-item-price">
                          ${productPrice}
                          ${
                            showComparePrice
                              ? `<del class="slidecart-item-compare-price">${formatPriceShopify(effectiveCompareAtPrice)}</del>`
                              : ""
                          }
                        </span>
                        ${
                          isBonusItem || isFreeGiftProperty
                            ? ""
                            : `<div class="slidecart-qty-wrapper">
                              <button class="qty-button qty-minus-button js-minus-button" data-minus data-qty-button data-key="${productKey}" aria-label="Decrease quantity">-</button>
                              <input class="cart-qty-input js-cart-qty-input" type="number" inputmode="numeric" pattern="[0-9]*" min="0" data-input-key="${productKey}" value="${productQuantity}" aria-label="Item quantity"/>
                              <button class="qty-button qty-plus-button js-plus-button" data-plus data-qty-button data-key="${productKey}" aria-label="Increase quantity">+</button>
                            </div>`
                        }
                      </div>
                    </div>
                    ${
                      !isBonusItem
                        ? `
                      <button class="cart-item-payment-options__button ${toggleButtonClass}"
                        key="${productKey}"
                        qty="${productQuantity}"
                        plan_id="${sellingPlanId}"
                        product_id="${productId}"
                        data-cart-toggle-subscribe
                      >
                        ${
                          discount
                            ? `Click here to become a member and save ${discount} on this order`
                            : "Become a member and save on this order"
                        }
                      </button>
                    `
                        : ""
                    }
                  </div>
                </div>`;

              $(`[slidecart-product-wrapper]`).append(concatProductInfo);
              resolve();
            })
            .fail((error) => {
              console.error(
                `Failed to load product data for ${productHandle}:`,
                error
              );

              const removeButtonClass = isBonusItem
                ? "removeItem disabled"
                : "removeItem";
              const removeButtonText = isBonusItem ? "" : REMOVE_BUTTON_LABEL;

              const showComparePrice =
                productCompareAtPrice &&
                parseFloat(productCompareAtPrice) > parseFloat(item.itemPrice) &&
                (
                  productPlanAllocation ||
                  isBonusItem ||
                  isBundleParent
                );

              const concatProductInfo = `
                <div class="slidecart-item-wrapper"
                  data-slidecart-item="${productId}"
                  data-line="${Number(index + 1)}"
                  data-bundle-child-keys="${bundleChildKeys}"
                  data-bundle-child-quantities="${bundleChildQuantities}"
                  data-bundle-id="${productBundleID}"
                  data-bundle-parent-key="${bundleParentKey}"
                  data-is-bonus-item="${isBonusItem}"
                  data-bundle-bonus-id="${bundleBonusId}"
                  data-is-bundle-parent="${isBundleParent}"
                >
                  <div class="slidecart-item-image-wrapper">
                    ${
                      isBonusItem
                        ? productImage
                        : `<a href="${productUrl}">${productImage}</a>`
                    }
                  </div>
                  <div class="slidecart-item-details-wrapper">
                    <div class="slidecart-item-details-top">
                      <div class="slidecart-item-description-wrapper">
                        ${
                          isBonusItem
                            ? `<span class="slidecart-item-title slidecart-item-title--bonus">${productTitle}</span>`
                            : `<a class="slidecart-item-title" href="${productUrl}">${productTitle}</a>`
                        }
                        ${isBonusItem ? "" : bundleItemList}
                        ${
                          isBonusItem
                            ? `<span class="slidecart-item-purchase-frequency">Bonus Item</span>`
                            : ""
                        }
                      </div>
                      <div class="slidecart-item-qty-wrapper">
                        <span class="${removeButtonClass}" data-remove-key="${productKey}">${removeButtonText}</span>
                        <span class="slidecart-item-price">
                          ${productPrice}
                          ${
                            showComparePrice
                              ? `<del class="slidecart-item-compare-price">${formatPriceShopify(productCompareAtPrice)}</del>`
                              : ""
                          }
                        </span>
                        ${
                          isBonusItem
                            ? ""
                            : `<div class="slidecart-qty-wrapper">
                              <button class="qty-button qty-minus-button js-minus-button" data-minus data-qty-button data-key="${productKey}" aria-label="Decrease quantity">-</button>
                              <input class="cart-qty-input js-cart-qty-input" type="number" inputmode="numeric" pattern="[0-9]*" min="0" data-input-key="${productKey}" value="${productQuantity}" aria-label="Item quantity"/>
                              <button class="qty-button qty-plus-button js-plus-button" data-plus data-qty-button data-key="${productKey}" aria-label="Increase quantity">+</button>
                            </div>`
                        }
                      </div>
                    </div>
                  </div>
                </div>`;

              $(`[slidecart-product-wrapper]`).append(concatProductInfo);
              resolve();
            });
        });

        renderPromises.push(renderPromise);
      });

      await Promise.all(renderPromises);

      const discountedTotal = cart.items_subtotal_price / 100;
      const savings = originalTotal - discountedTotal;

      $(`[data-slidecart-total-value]`).html(
        formatPriceShopify(discountedTotal.toFixed(2))
      );

      console.log(
        "Debug - Final Original Total:", originalTotal,
        "Discounted Total:", discountedTotal,
        "Savings:", savings
      );

      if (savings > 0) {
        $(`[cart-subtotal]`).html(`
          <div class="cart-totals-enhanced">
            <div class="cart-totals-left">subtotal</div>
            <div class="cart-totals-right">
              <div class="cart-savings-message">you save ${formatPriceShopify(
                savings.toFixed(2)
              )}</div>
              <div class="cart-totals-section">
                <div class="cart-original-total"><del>${formatPriceShopify(
                  originalTotal.toFixed(2)
                )}</del></div>
                <div class="cart-discounted-total">${formatPriceShopify(
                  discountedTotal.toFixed(2)
                )}</div>
              </div>
            </div>
          </div>
        `);
      } else {
        $(`[cart-subtotal]`).html(
          formatPriceShopify(discountedTotal.toFixed(2))
        );
      }
    } catch (error) {
      console.error("Failed to load cart:", error);
      isRenderingCart = false;
    } finally {
      hideNonShopPayButtons();
      renderUpsells();
      isRenderingCart = false;
    }
  }

  window.lsgSlideCartOpen = function () {
    slideCartOpen();
  };
  function slideCartOpen() {
    $(`#slidecart-wrapper`).addClass("active");
    $(`[slidecart-overlay]`).addClass("active");
    $("html, body").css("overflow", "hidden");
    renderCart();

    // Dispatch event for slidecart opened
    document.dispatchEvent(new CustomEvent("slidecart:opened"));

    // mixpanel.track('Open Cart');
  }
  window.lsgSlideCartClose = function () {
    slideCartClose();
  };
  function slideCartClose() {
    $(`#slidecart-wrapper`).removeClass("active");
    $("html, body").css("overflow", "auto");
    $(`[slidecart-overlay]`).removeClass("active");
  }
  // locale-safe: casa /cart e /<locale>/cart (ex: /en-gb/cart) em Shopify Markets
  $('[href$="/cart"]').on("click", function (e) {
    e.preventDefault();
    slideCartOpen();
  });
  /* $('form[action="/cart/add"]').on('submit', function(e){
        e.preventDefault();
        console.log(e);
    }); */
  $(document).on("click", "[data-slidecart-trigger]", function () {
    slideCartOpen();
  });
  $(document).on(
    "click",
    "[data-close-slidecart], [slidecart-overlay]",
    function () {
      slideCartClose();
    }
  );
  if (window.location.href.indexOf("?cart-opened") > -1) {
    slideCartOpen();
  }
  function clearCartDrawer() {
    $(`[slidecart-product-wrapper]`).html("");
  }
  const bindSlideCartUIActions = () => {
    function updateItemQuantity(target, key, newQty, currentQty = 1) {
      const bundleChildKeys = $(target)
        .closest("[data-bundle-child-keys]")
        .attr("data-bundle-child-keys");
      const bundleChildQuantities = $(target)
        .closest("[data-bundle-child-keys]")
        .attr("data-bundle-child-quantities");
      const isBundleParent = bundleChildKeys !== "" ? true : false;

      // Check if we need to handle bonus items (when removing a bundle parent)
      const $itemWrapper = $(target).closest(".slidecart-item-wrapper");
      const bundleId = $itemWrapper.attr("data-bundle-id");
      const isRemovingBundleParent = isBundleParent && newQty === 0 && bundleId;

      // if this is a bundle parent product
      if (isBundleParent) {
        const childKeysArray = bundleChildKeys.split(",");
        const childQuantitiesArray = bundleChildQuantities.split(",");

        let formData = {
          updates: {},
        };

        childKeysArray.forEach((childKey, i) => {
          const currentChildQty = parseInt(childQuantitiesArray[i]);
          let newChildQty = (currentChildQty / currentQty) * newQty;
          if (newChildQty < 0) newChildQty = 0;

          formData["updates"][String(childKey)] = newChildQty;
        });

        // If removing bundle parent, also remove associated bonus items
        if (isRemovingBundleParent) {
          // Get current cart to find bonus items
          $.ajax({
            type: "GET",
            url: window.Shopify.routes.root + "cart.js",
            dataType: "json",
            success: function (cart) {
              const bonusItems = getBonusItemsForBundle(cart, bundleId);

              // Add bonus items to the updates object
              bonusItems.forEach((item) => {
                formData["updates"][String(item.key)] = 0;
              });

              // Now perform the update with both bundle and bonus items
              $.ajax({
                type: "POST",
                url: window.Shopify.routes.root + "cart/update.js",
                data: formData,
                dataType: "json",
                success: function () {
                  renderCart();
                },
              });
            },
          });
        } else {
          // Normal bundle update without bonus item handling
          $.ajax({
            type: "POST",
            url: window.Shopify.routes.root + "cart/update.js",
            data: formData,
            dataType: "json",
            success: function () {
              renderCart();
            },
          });
        }
      } else {
        const data = {
          id: key,
          quantity: newQty,
        };

        $(`[data-input-key="${key}"]`).attr("value", newQty);

        $.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/change.js",
          data: data,
          dataType: "json",
          success: function () {
            renderCart();
          },
        });
      }
    }

    // Update item quantity
    // $(document).off().on('click', `[data-qty-button]`, (event) => {
    $(document).on("click", `[data-qty-button]`, (event) => {
      event.preventDefault();

      const key = $(event.target).attr("data-key");
      const currentQty = parseInt($(`[data-input-key="${key}"]`).attr("value"));
      let newQty;

      if ($(event.target).hasClass("js-plus-button")) {
        newQty = currentQty + 1;
      } else {
        newQty = currentQty - 1;
        if (newQty < 0) newQty = 0;
      }

      updateItemQuantity(event.target, key, newQty, currentQty);
    });

    // Remove item
    // $(`span.removeItem`).click(function () {
    $(document).on("click", `.slidecart-wrapper span.removeItem`, function (e) {
      var key = $(this).attr("data-remove-key"); // CHANGE HERE

      // Check if this is a bonus item and prevent removal
      var $itemWrapper = $(this).closest(".slidecart-item-wrapper");
      var isBonusItem = $itemWrapper.attr("data-is-bonus-item") === "true";

      if (isBonusItem || $(this).hasClass("disabled")) {
        e.preventDefault();
        return false;
      }

      // updateItemQuantity now handles bonus item removal automatically
      updateItemQuantity(e.target, key, 0);
    });

    // Add upsell
    $(document).on("click", "[data-upsell-atc]", (event) => {
      var variantId = $(event.target).attr("data-upsell-atc");
      var data = {
        id: variantId,
        quantity: 1,
      };
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: data,
        dataType: "json",
        success: () => {
          renderCart();
        },
      });
    });

    // Toggle OTP to Subscribe
    $(document).on("click", "[data-cart-toggle-subscribe]", (event) => {
      event.preventDefault();
      updateItemSubscription(event);
    });

    // CUSTOM BUNDLE CREATE PDP PAGE ATC JS START
    function checkisSubscribe(){
      if(document.querySelector('.product__block.subscriptions')!=null){
        var subscriptionWrap = document.querySelector('.product__block.subscriptions');
        var subscriptionType = subscriptionWrap.querySelector('.subscriptions__icon.subscriptions__icons--nactive').getAttribute('aria-hidden');
        var type=0;
        if(subscriptionType == 'true'){
          type=1;
        }
        return type;
      }
    }

    function getSelectedIntervalCount() {
      var hiddenInput = document.querySelector('[data-single-option-selector]');
      if (!hiddenInput) return null;

      var selectedPlanId = hiddenInput.value;

      var matchingOption = document.querySelector('a.select-popout__option[data-selling-plan-id="' + selectedPlanId + '"]');
      if (!matchingOption) return null;

      try {
        var optionsJson = JSON.parse(matchingOption.getAttribute('data-selling-plan-options'));
        var valueStr = optionsJson[0].value;
        var match = valueStr.match(/\d+/);
        return match ? match[0] : null;
      } catch (e) {
        return null;
      }
    }

    function getMatchingFlavorQty(row, nonDecafIndex) {
      const activeItems = document.querySelectorAll(
        '.flavour_accordian .flavor-item:not(.flavor-hide):not(.flavor-item-4)'
      );

      const rowTitle = row.dataset.productTitle?.toLowerCase().trim() || "";

      for (let i = 0; i < activeItems.length; i++) {
        const item = activeItems[i];
        const itemTitle = item.querySelector('.flavor-name, .flavor-title, h3, h4, strong, span')
          ?.textContent?.toLowerCase().trim() || "";

        if (itemTitle && rowTitle.includes(itemTitle) || itemTitle.includes(rowTitle)) {
          const qtyEl = item.querySelector('.flavor-qty-value');
          const qty = parseInt(qtyEl?.textContent.match(/\d+/)?.[0], 10);
          return isNaN(qty) ? null : qty;
        }
      }
      if (activeItems[nonDecafIndex]) {
        const qtyEl = activeItems[nonDecafIndex].querySelector('.flavor-qty-value');
        const qty = parseInt(qtyEl?.textContent.match(/\d+/)?.[0], 10);
        return isNaN(qty) ? null : qty;
      }

      return null;
    }

    function freeFlavorQuantity() {
      const quantities = {};

      document.querySelectorAll(
        '.flavour_accordian .flavor-item:not(.flavor-hide):not(.flavor-item-4)'
      ).forEach(function(item) {
        const qtyEl = item.querySelector('.flavor-qty-value');
        if (!qtyEl) return; // element na mle to skip

        const handle = qtyEl.getAttribute('data-handle');
        if (!handle) return; // handle na hoy to skip

        const qty = parseInt(qtyEl.textContent.trim(), 10);
        if (!isNaN(qty)) {
          quantities[handle] = qty;
        }
      });

      return quantities;
    }

    function getFreeProductsToAdd() {
      const items = [];

      var type = checkisSubscribe();
      var isSubscription = type == 1;

      var intervalCount = null;
      if (isSubscription) {
        intervalCount = getSelectedIntervalCount();
      }

      const rows = document.querySelectorAll('#bundleFreeProducts .bundle_free_row');
      if (!rows.length) return items;

      const flavorQuantities = freeFlavorQuantity();

      rows.forEach((row) => {
        try {
          const isDecaf = row.dataset.isDecaf === 'true';

          // Decaf check
          if (isDecaf) {
          }

          const variantId = row.getAttribute('free-variant-id');
          if (!variantId) return;

          var getFreeHandle = row.getAttribute('free-product-handle');

          let boxQuantity;

          if (isDecaf) {
            // Decaf ni quantity decaf item na potana text value thi j levi
            const decafQtyEl = document.querySelector('.flavour_accordian .flavor-item-4 .flavor-qty-value');
            const decafQty = parseInt(decafQtyEl?.textContent.match(/\d+/)?.[0], 10);
            boxQuantity = !isNaN(decafQty) ? Math.round(decafQty / 10) : 3;
          } else {
            // Handle match karo
            const matchedEntry = getFreeHandle
              ? Object.entries(flavorQuantities).find(([handle]) => {
                  const handleBase = handle.toLowerCase().split('-')[0];
                  return getFreeHandle.toLowerCase().includes(handleBase);
                })
              : null;

            const flavorQty = matchedEntry ? matchedEntry[1] : null;
            boxQuantity = (flavorQty !== null && !isNaN(flavorQty))
              ? Math.round(flavorQty / 10)
              : 3;
          }

          const item = {
            id: parseInt(variantId, 10),
            quantity: boxQuantity,
            properties: { _is_free_gift: 'true' },
            _isDecaf: isDecaf // internal flag — cart add karta pehla remove karvanu
          };

          // Selling plan
          if (isSubscription && intervalCount) {
            const planMapStr = row.dataset.planMap;
            if (planMapStr) {
              const planMap = {};
              planMapStr.split(',').forEach(function(pair) {
                const parts = pair.split(':');
                if (parts.length === 2) planMap[parts[0].trim()] = parts[1].trim();
              });

              const matchedPlanId = planMap[intervalCount];
              if (matchedPlanId) {
                item.selling_plan = parseInt(matchedPlanId, 10);
              }
            }
          }

          items.push(item);

        } catch(e) {
          console.error('getFreeProductsToAdd row error:', e);
        }
      });

      return items;
    }

    function getDecafFreeGift() {
      return document.querySelector('.bundle_free_row.decaf-gift');
    }

    function getfreeGiftSelected() {
      let variantIds = [];
      if (document.querySelector('.free_products_grid_row.unlock:not(.decaf-gift)') != null) {
        const unlockedRows = document.querySelectorAll('.free_products_grid_row.unlock:not(.decaf-gift)');
        unlockedRows.forEach(row => {
          const variantId = row.getAttribute('free-variant-id');
          if (variantId != null && variantId != undefined) {
            if (variantId) variantIds.push(variantId);
          }
        });
      }
      return variantIds;
    }

    function getBundleID() {
      let d = new Date().getTime();
      let d2 = (performance && performance.now && performance.now() * 1000) || 0;
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        let r = Math.random() * 16;
        if (d > 0) {
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
      });
    }

    $(document).on("click", ".coffybox_newbundle_box .product__submit__bundle", function (event) {
      var btnObj = $(this);
      btnObj.addClass('is-loading');

      var type = checkisSubscribe();
      var sellingPlanId = 0;
      var kitWrapper = document.querySelector('.kit-selector__list .kit-card.kit-card--selected');
      var variantId = kitWrapper.getAttribute('data-variant-id');
      if (type == 1) {
        var subscribeWrapper = document.querySelector('.subscriptions #subscriptions__frequence-selector');
        if (subscribeWrapper && subscribeWrapper.querySelector('.select-popout .select-popout__value') != null) {
          var weekOption = subscribeWrapper.querySelector('.select-popout .select-popout__value').innerText;
          var variantSelect = document.querySelector('.variant_wise_' + variantId);
          if (variantSelect && weekOption != undefined && weekOption != "") {
            var options = variantSelect.querySelectorAll('option');
            options.forEach(function(option) {
              var optionText = option.textContent.trim();
              weekOption = weekOption.toLowerCase().replace(/\s+/g, '-');

              var optionHandle = optionText.toLowerCase().replace(/\s+/g, '-');
              if (optionHandle === weekOption && option.value != '') {
                sellingPlanId = option.value;
              }
            });
          }
        }
      }
      var getVariantImg = kitWrapper.getAttribute('data-v-image');

      var getFreeVariantAll = getfreeGiftSelected();

      var bundleId = getBundleID();
      var bonusBundleId = bundleId;
      var freeGiftPrice = 0;
      if (document.querySelector('.free_products_list .dynamic_prize') != null) {
        var priceWrap = document.querySelector('.free_products_list .dynamic_prize h4');
        if (priceWrap) {
          freeGiftPrice = priceWrap.querySelector('strong').innerText;
        }
      }

      // bundleFreeItems moved up so its variant ids are ready before mainItem is built
      var bundleFreeItems = getFreeProductsToAdd().map(function (item) {
        item.properties = item.properties || {};
        item.properties._bundle_id = bundleId;
        return item;
      });

      // decaf ne _free_gift_variants property list mathi exclude karo
      var bundleFreeVariantIds = bundleFreeItems
        .filter(function (item) { return !item._isDecaf; })
        .map(function (item) { return item.id; });

      // Selected card compare price get
      var selectedKitCard = document.querySelector('.kit-selector__list .kit-card.kit-card--selected');
      var kitComparePrice = '';
      if (selectedKitCard) {
        var compareEl = selectedKitCard.querySelector('.kit-card__compare');
        if (compareEl && compareEl.innerText) {
          kitComparePrice = compareEl.innerText;
        }
      }

      var mainItem = {
        id: variantId,
        quantity: 1,
        ...(sellingPlanId != 0 && { selling_plan: sellingPlanId }),
        properties: {
          _free_gift_variants: bundleFreeVariantIds.join(','), // decaf variant id have ismei nathi
          _variant_image: getVariantImg,
          _bundle_id: bundleId,
          _bundle_parent: true,
          _bundle_free_price: freeGiftPrice,
          _bundle_compare_price: kitComparePrice
        }
      };

      var toggleItem = null;
      var checkbox = document.getElementById('myToggle');
      if (checkbox && checkbox.checked && checkbox.value) {
        toggleItem = {
          id: checkbox.value,
          quantity: 1,
          properties: {
            _is_toggle_addon: 'true',
            _bundle_id: bundleId
          }
        };
      }

      var newFreeItems = getFreeVariantAll.map(function(freeVariant) {
        return {
          id: freeVariant,
          quantity: 1,
          properties: {
            _is_free_gift: 'true',
            _is_unlock_gift: 'true',
            _bundle_id: bundleId,
            _bundle_bonus_id: bonusBundleId
          }
        };
      });

      bundleFreeItems.forEach(function(item) {
        delete item._isDecaf; // internal flag hatavo, cart add ma nathi jaavu
        newFreeItems.push(item);
      });

      var allItems = [mainItem];
      if (toggleItem) allItems.push(toggleItem);
      if (newFreeItems.length > 0) allItems.push(...newFreeItems);

      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: JSON.stringify({ items: allItems }),
        contentType: "application/json",
        dataType: "json"
      })
        .then(function() {
          window.lsgRenderCart();
          if ($(".menu__item .cart__toggle").length > 0) {
            $(".menu__item .cart__toggle").trigger("click");
          } else {
            window.lsgSlideCartOpen();
          }
          btnObj.removeClass('is-loading');
        })
        .catch(function(xhr) {
          btnObj.removeClass('is-loading');
          var message = "Something went wrong. Please try again.";
          try {
            var response = typeof xhr.responseText === 'string'
              ? JSON.parse(xhr.responseText) : xhr;
            if (response.description) message = response.description;
            else if (response.message) message = response.message;
          } catch(e) {}
          alert(message);
        });
    });

    function showCartLoader() {
      document.getElementById('cartDrawerLoader').classList.add('active');
    }
    function hideCartLoader() {
      document.getElementById('cartDrawerLoader').classList.remove('active');
    }

    function removeItemWithBonus(removeKey) {
      showCartLoader();
      fetch(window.Shopify.routes.root + "cart.js")
        .then(res => res.json())
        .then(cart => {

          let keysToRemove = [removeKey];

          // Main product find
          const mainCartItem = cart.items.find(item => item.key === removeKey);

                    let linkedFreeVariants = [];
          const removedBundleId =
            (mainCartItem && mainCartItem.properties && mainCartItem.properties._bundle_id) || null;

          // Free gift variants
          if (
            mainCartItem &&
            mainCartItem.properties &&
            mainCartItem.properties._free_gift_variants
          ) {
            linkedFreeVariants = mainCartItem.properties._free_gift_variants
              .split(',')
              .map(v => v.trim());
          }

          // Linked free gifts only (NO addon removal)
          cart.items.forEach(item => {
            const isFreeGift =
              item.properties &&
              item.properties._is_free_gift === 'true';

            // Same variants are granted by every kit, so variant alone also
            // matches gifts belonging to a different kit still in the cart.
            // Require the gift to come from the kit being removed.
            const isLinked =
              linkedFreeVariants.includes(String(item.variant_id)) &&
              (!removedBundleId ||
                (item.properties && item.properties._bundle_id === removedBundleId));

            if (isFreeGift && isLinked) {
              keysToRemove.push(item.key);
            }
          });


          // Duplicate remove
          keysToRemove = [...new Set(keysToRemove)];


          return keysToRemove.reduce((promiseChain, key) => {
            return promiseChain.then(() =>
              fetch(window.Shopify.routes.root + "cart/change.js", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              })
            );
          }, Promise.resolve());

        })
        .then(() => {
          window.lsgRenderCart();
          hideCartLoader();
        })
        .catch(err => {
          console.error(err);
          hideCartLoader();
        });
    }

    $(document).on("click", ".removeItem:not(.disabled)", function () {
      var removeKey = $(this).attr("data-remove-key");
      removeItemWithBonus(removeKey);
    });

    $(document).on("click", ".js-minus-button", function () {
      var key = $(this).attr("data-key");
      var $input = $('[data-input-key="' + key + '"]');
      var currentQty = parseInt($input.val());

      if (currentQty <= 1) {
        removeItemWithBonus(key);
      } else {
        showCartLoader();
        var newQty = currentQty - 1;
        $input.val(newQty);
        $.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/update.js",
          data: JSON.stringify({ updates: { [key]: newQty } }),
          contentType: "application/json",
          dataType: "json",
          success: function () {
            window.lsgRenderCart();
            hideCartLoader();
          },
          error: function () {
            hideCartLoader();
          }
        });
      }
    });

    // CUSTOM BUNDLE CREATE PDP PAGE ATC JS END

    // Change Subscription Plan
    $(document).on("change", "[data-subscribe-select]", (event) => {
      event.preventDefault();
      updateItemSubscription(event);
    });

    $(document).on("click", "[add-upsell]", function () {
      var id = $(this).attr("variant-id");
      var data = {
        id: id,
        quantity: 1,
      };
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          renderCart();
        },
      });
    });
  };
  bindSlideCartUIActions();
  const obscureCartData = (cart) => {
    let obscuredCartData = [];
    cart.items.forEach((item) => {
      const itemPrice = parseFloat(item.line_price / 100)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
        .toString();

      const tempIsBonusItem =
        item.properties !== null
          ? item.properties._bundle_bonus_id !== undefined
            ? true
            : false
          : false;

      let itemCompareAtPrice = null;

      if (tempIsBonusItem) {
        if (typeof BONUS_ITEMS_IDS !== "undefined") {
          for (const [productId, config] of Object.entries(BONUS_ITEMS_IDS)) {
            if (
              config.variants &&
              Object.values(config.variants).includes(item.variant_id)
            ) {
              if (config.compare_at_price) {
                const convertedPrice =
                  typeof getBonusItemCompareAtPrice !== "undefined"
                    ? getBonusItemCompareAtPrice(productId)
                    : convertEurToActiveCurrency(config.compare_at_price);

                itemCompareAtPrice = parseFloat(convertedPrice / 100)
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
                  .toString();
              }
              break;
            }
          }
        }

        // Fallback: BONUS_ITEMS_IDS compare_at_price
        if (!itemCompareAtPrice && item.original_price && item.original_price > item.price) {
          itemCompareAtPrice = parseFloat(item.original_price / 100)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
            .toString();
        }
      } else {
        itemCompareAtPrice =
          item.selling_plan_allocation !== undefined
            ? item.selling_plan_allocation.compare_at_price
              ? parseFloat(item.selling_plan_allocation.compare_at_price / 100)
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
                  .toString()
              : null
            : item.properties && item.properties._subscription_price
            ? parseFloat(item.properties._subscription_price / 100)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
                .toString()
            : item.original_price && item.original_price > item.price
            ? parseFloat(item.original_price / 100)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
                .toString()
            : null;
      }

      const selectedVid = item.variant_id;
      const itemSellingPlanAllocation =
        item.selling_plan_allocation !== undefined ? true : false;
      const itemPlanId =
        item.selling_plan_allocation !== undefined
          ? item.selling_plan_allocation.selling_plan.id
          : false;
      const itemPlanType =
        item.selling_plan_allocation !== undefined
          ? item.selling_plan_allocation.selling_plan.name
          : false;

      const isUnlockGift =
        item.properties !== null
          ? item.properties._is_unlock_gift === "true"
            ? true
            : false
          : false;

      const isToggleAddon =
        item.properties !== null
          ? item.properties._is_toggle_addon === "true"
            ? true
            : false
          : false;

      const itemBundleID =
        item.properties !== null
          ? item.properties._bundle_id !== undefined
            ? item.properties._bundle_id
            : false
          : false;

      const isBundleChild =
        item.properties !== null
          ? item.properties._bundle_id !== undefined &&
            item.properties._bundle_parent === undefined &&
            item.properties._bundle_bonus_id === undefined &&
            !isUnlockGift &&
            !isToggleAddon
            ? true
            : false
          : false;

      const isBundleParent =
        item.properties !== null
          ? item.properties._bundle_parent === true
            ? true
            : false
          : false;

      const isFreeGiftProduct =
        item.properties !== null
          ? item.properties._is_free_gift === "true"
            ? true
            : false
          : false;

      const isExtraImage =
        item.properties !== null
          ? item.properties._variant_image != undefined
            ? true
            : false
          : false;

      const isBonusItemFlag =
        item.properties !== null
          ? item.properties._bundle_bonus_id !== undefined
            ? true
            : false
          : false;

      const bundleBonusId =
        item.properties !== null
          ? item.properties._bundle_bonus_id !== undefined
            ? item.properties._bundle_bonus_id
            : false
          : false;

      var isVariantImage = null;
      if (isExtraImage) {
        isVariantImage = item.properties._variant_image;
      }

      // ─── _bundle_free_price parse ───
      let bundleFreePrice = 0;
      if (
        isBundleParent &&
        item.properties &&
        item.properties._bundle_free_price
      ) {
        const cleaned = item.properties._bundle_free_price
          .toString()
          .replace(/[€$£\s]/g, "")
          .replace(",", ".");
        const parsed = parseFloat(cleaned);
        if (!isNaN(parsed) && parsed > 0) {
          bundleFreePrice = parsed;
        }
      }

      // ─── _bundle_compare_price parse ───
      let bundleComparePrice = null;

      // ✅ FIX: _bundle_compare_price property exist કરે છે કે નહીં તે track કરો
      // જો exist કરે (ભલે blank હોય) → intentionally no compare price show કરવો
      const bundleComparePriceExists =
        isBundleParent &&
        item.properties &&
        '_bundle_compare_price' in item.properties;

      if (
        isBundleParent &&
        item.properties &&
        item.properties._bundle_compare_price &&
        item.properties._bundle_compare_price !== ''
      ) {
        const cleaned = item.properties._bundle_compare_price
          .toString()
          .replace(/[€$£\s]/g, '')
          .replace(',', '.');
        const parsed = parseFloat(cleaned);
        if (!isNaN(parsed) && parsed > 0) {
          bundleComparePrice = parsed
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, '$1')
            .toString();
        }
      }

      let cartDataItem = {
        itemID: item.id,
        itemTitle: item.title,
        itemHandle: item.handle,
        itemImage: item.image,
        itemPrice: itemPrice,
        itemQuantity: item.quantity,
        itemGrams: item.grams,
        itemUrl: item.url,
        itemKey: item.key,
        itemSellingPlanAllocation: itemSellingPlanAllocation,
        itemPlanId: itemPlanId,
        itemCompareAtPrice: itemCompareAtPrice,
        itemPlanType: itemPlanType,
        itemBundleID: itemBundleID,
        isBundleChild: isBundleChild,
        isUnlockGift: isUnlockGift,
        isToggleAddon: isToggleAddon,
        isBundleParent: isBundleParent,
        isBonusItem: isBonusItemFlag,
        isFreeGiftProduct: isFreeGiftProduct,
        bundleBonusId: bundleBonusId,
        isVariantImage: isVariantImage,
        bundleChildKeys: "",
        bundleChildQuantities: "",
        bundleItemList: "",
        bundleParentKey: "",
        selectedVid:selectedVid,
        itemTags: [],
        _bundleFreePrice: bundleFreePrice,
        _bundleComparePrice: bundleComparePrice,
        _bundleComparePriceExists: bundleComparePriceExists, // ✅ NEW FLAG
      };

      obscuredCartData.push(cartDataItem);
    });

    let removalIndexes = [];
    obscuredCartData.forEach((mainItem) => {
      if (mainItem.isBundleParent) {
        const mainItemBundleID = mainItem.itemBundleID;

        if (mainItemBundleID) {
          let bundleChildKeys = [];
          let bundleChildQuantities = [];
          let bundleItemList = "";

          obscuredCartData.forEach((comparedItem, i) => {
            const comparedItemBundleID = comparedItem.itemBundleID;
            const comparedItemPrice = parseFloat(comparedItem.itemPrice);

            if (
              comparedItem.isBundleParent === false &&
              comparedItemBundleID === mainItemBundleID &&
              !comparedItem.bundleBonusId &&
              !comparedItem.isUnlockGift &&
              !comparedItem.isToggleAddon
            ) {
              bundleChildKeys.push(comparedItem.itemKey);
              bundleChildQuantities.push(comparedItem.itemQuantity);
              bundleItemList +=
                '<li class="cart-item-bundle-el">' +
                comparedItem.itemTitle +
                (comparedItem.itemQuantity > 1
                  ? " (" + comparedItem.itemQuantity + ")"
                  : "") +
                "</li>";
              mainItem.itemPrice = parseFloat(
                parseFloat(mainItem.itemPrice) + comparedItemPrice
              ).toFixed(2);
              removalIndexes.push(i);
            }

            if (
              comparedItem.isBundleParent === true &&
              comparedItemBundleID === mainItemBundleID
            ) {
              bundleChildKeys.push(comparedItem.itemKey);
              bundleChildQuantities.push(comparedItem.itemQuantity);
              mainItem.bundleParentKey = comparedItem.itemKey;
            }
          });

          mainItem.bundleChildKeys = bundleChildKeys;
          mainItem.bundleChildQuantities = bundleChildQuantities;
          mainItem.bundleItemList =
            bundleItemList != ""
              ? '<ul class="cart-item-bundle-items">' + bundleItemList + "</ul>"
              : "";

          // ✅ FIX: Compare price logic
          if (mainItem._bundleComparePrice) {
            // Valid _bundle_compare_price value → use it
            mainItem.itemCompareAtPrice = mainItem._bundleComparePrice;
          } else if (mainItem._bundleComparePriceExists) {
            // _bundle_compare_price property exist કરે છે પણ blank/empty છે
            // → intentionally compare price null કરો, કંઈ show ન કરો
            mainItem.itemCompareAtPrice = null;
          } else if (mainItem._bundleFreePrice > 0 && mainItem.itemCompareAtPrice) {
            // _bundle_free_price છે અને existing compare price પણ છે → combine
            const existingCompare = parseFloat(mainItem.itemCompareAtPrice.replace(/[^0-9.]/g, ""));
            const totalCompare = existingCompare + mainItem._bundleFreePrice;
            mainItem.itemCompareAtPrice = totalCompare
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
              .toString();
          } else if (mainItem._bundleFreePrice > 0) {
            // _bundle_free_price છે, existing compare price નથી → current price + free price
            const currentPrice = parseFloat(mainItem.itemPrice);
            const totalCompare = currentPrice + mainItem._bundleFreePrice;
            mainItem.itemCompareAtPrice = totalCompare
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1")
              .toString();
          } else {
            // Bundle parent, કોઈ compare price source નથી → null
            mainItem.itemCompareAtPrice = null;
          }
        }
      }
    });

    obscuredCartData = obscuredCartData.filter((item, index) => {
      return removalIndexes.indexOf(index) == -1;
    });

    obscuredCartData.sort((a, b) => {
      if (
        a.itemBundleID &&
        b.itemBundleID &&
        a.itemBundleID === b.itemBundleID
      ) {
        if (a.bundleBonusId && !b.bundleBonusId) return -1;
        if (!a.bundleBonusId && b.bundleBonusId) return 1;
        return 0;
      }
      return 0;
    });

    return obscuredCartData;
  };


  const updateQuantityElements = (data) => {
    const obscuredCartData = data;
    let cartQty = 0;
    obscuredCartData.forEach((item, index) => {
      if (item.isBundleChild) return;
      cartQty = cartQty + item.itemQuantity;
    });
    $("[data-cart-slider-total-quantity]").html(`(${cartQty})`);
    $("[data-lsg-cart-count]").html(cartQty);

    // Update slidecart item counter
    const $slidecartItemsQty = $("[data-slidecart-items-qty]");
    if (cartQty === 0) {
      $slidecartItemsQty.addClass("hidden");
    } else {
      $slidecartItemsQty.removeClass("hidden");
      const itemText = cartQty === 1 ? `${cartQty} item` : `${cartQty} items`;
      $slidecartItemsQty.text(itemText);
    }
  };
  const updateItemSubscription = (event) => {
    let key,
      qty,
      plan,
      oldPlan,
      id,
      additionDataArray = {},
      removalData = {
        updates: {},
      };

    if ($(event.target).is("[data-cart-toggle-subscribe]")) {
      key = $(event.target).attr("key");
      id = parseInt($(event.target).attr("product_id"));
      qty = parseInt($(event.target).attr("qty"));
      plan = parseInt($(event.target).attr("plan_id"));
    }
    if ($(event.target).is("[data-subscribe-select]")) {
      key = $("option:selected", $(event.target)).attr("key");
      id = parseInt($("option:selected", $(event.target)).attr("product_id"));
      qty = parseInt($("option:selected", $(event.target)).attr("qty"));
      plan = parseInt($("option:selected", $(event.target)).attr("value"));
      oldPlan = parseInt($("option:selected", $(event.target)).attr("plan_id"));
    }

    const isOTP = isNaN(parseFloat(plan));

    if (oldPlan === plan) return;

    // Determine if this is a bundle parent
    const bundleChildKeys = $(event.target)
      .closest("[data-bundle-child-keys]")
      .attr("data-bundle-child-keys");
    const bundleChildQuantities = $(event.target)
      .closest("[data-bundle-child-quantities]")
      .attr("data-bundle-child-quantities");
    const bundleID = $(event.target)
      .closest("[data-bundle-id]")
      .attr("data-bundle-id");
    const bundleParentKey = $(event.target)
      .closest("[data-bundle-parent-key]")
      .attr("data-bundle-parent-key");

    const isBundleParent = bundleChildKeys !== "" ? true : false;

    // if this is a bundle parent product
    if (isBundleParent === true) {
      const childKeysArray = bundleChildKeys.split(",");
      const childQuantitiesArray = bundleChildQuantities.split(",");

      let product_data = childKeysArray.map((childKey, i) => {
        const childIsBundleParent = childKey === bundleParentKey ? true : false;
        const currentChildQty = parseInt(childQuantitiesArray[i]);
        const childID = parseInt(childKey.split(":")[0]);

        removalData["updates"][childKey] = 0;

        if (isOTP) {
          return {
            quantity: currentChildQty,
            id: childID,
            properties: {
              _bundle_id: bundleID,
              _bundle_parent: childIsBundleParent,
            },
          };
        } else {
          return {
            quantity: currentChildQty,
            id: childID,
            selling_plan: plan,
            properties: {
              _bundle_id: bundleID,
              _bundle_parent: childIsBundleParent,
            },
          };
        }
      });

      additionDataArray = {
        items: product_data,
      };
    } else {
      removalData["updates"][key] = 0;

      if (isOTP) {
        additionDataArray = {
          items: [
            {
              quantity: qty,
              id: id,
              properties: {
                _bundle_id: false,
                _bundle_parent: false,
              },
            },
          ],
        };
      } else {
        additionDataArray = {
          items: [
            {
              quantity: qty,
              id: id,
              selling_plan: plan,
              properties: {
                _bundle_id: false,
                _bundle_parent: false,
              },
            },
          ],
        };
      }
    }

    const reAddToCart = () => {
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(additionDataArray),
      })
        .then((response) => {
          /* products were added */

          if (isBundleParent === true) {
            renderCart();
          } else {
            // Add item if not added - edge case where added product gets deleted
            // ajax get cart
            $.ajax({
              type: "GET",
              url: window.Shopify.routes.root + "cart.js",
              dataType: "json",
              success: (cart) => {
                // check cart for product key,
                let productExists = false;
                cart.items.forEach((item) => {
                  const itemBundleID =
                    item.properties !== null
                      ? item.properties._bundle_id !== undefined
                        ? item.properties._bundle_id
                        : false
                      : false;
                  if (itemBundleID == false && item.id === id) {
                    productExists = true;
                  }
                });

                // if key doesn't exist add product again
                if (productExists === false) {
                  reAddToCart();
                } else {
                  // setTimeout(renderCart(), 500)
                  renderCart();
                }
              },
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/update.js",
      data: removalData,
      dataType: "json",
      success: () => {
        setTimeout(function () {
          reAddToCart();
        }, 750);
      },
    });
  };
  function renderUpsells() {
    $(`[slidecart-upsell-wrapper].flickity-enabled`).flickity("destroy");
    $(`[slidecart-upsell-wrapper]`).html("");
    $.ajax({
      type: "GET",
      url: window.Shopify.routes.root + "cart/?view=upselljson",
      dataType: "html",
      success: function (data) {
        $(`[slidecart-upsell-wrapper]`).html(data.trim());
        setTimeout(function () {
          renderUpsellSlider();
        }, 50);
      },
    });
  }
  function renderUpsellSlider() {
    if ($("[slidecart-upsell-wrapper] .slidecart-upsell").length > 1) {
      $(`[slidecart-upsell-wrapper]`).flickity({
        prevNextButtons: true,
        freeScroll: true,
        wrapAround: true,
        adaptiveHeight: true,
        contain: true,
      });
    }
  }

  // Countdown Timer Functionality
  function initCountdownTimer() {
    const COUNTDOWN_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds
    const STORAGE_KEY = "cart_countdown_end_time";

    let endTime = sessionStorage.getItem(STORAGE_KEY);

    // // If no end time exists or it's expired, create a new one
    if (!endTime || new Date().getTime() > parseInt(endTime)) {
      endTime = new Date().getTime() + COUNTDOWN_DURATION;
      sessionStorage.setItem(STORAGE_KEY, endTime.toString());
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const timeLeft = parseInt(endTime) - now;

      if (timeLeft <= 0) {
        // Timer expired, hide timer and show urgent message
        const timerElement = document.getElementById("countdown-timer");
        const messageElement = document.getElementById("countdown-message");

        if (timerElement && messageElement) {
          // Hide the timer element
          timerElement.style.display = "none";

          // Change the entire message to urgent text
          messageElement.innerHTML =
            "<strong>Limited stock - Order now before it's too late!</strong>";
          //  messageElement.style.backgroundColor = '#dc3545';
          //  messageElement.style.borderColor = '#b02a37';
          //  messageElement.style.color = 'white';
          //  messageElement.style.animation = 'pulse 1.5s infinite';
          //  messageElement.style.fontWeight = 'bold';

          // Reset timer after 60 seconds of showing urgent message
          setTimeout(() => {
            endTime = new Date().getTime() + COUNTDOWN_DURATION;
            sessionStorage.setItem(STORAGE_KEY, endTime.toString());

            // Restore original message and timer
            timerElement.style.display = "inline-block";
            timerElement.style.backgroundColor = "#333";
            messageElement.innerHTML =
              'We can only reserve your offer for <span id="countdown-timer" style="background-color: #333; color: white; padding: 2px 6px; border-radius: 6px; font-weight: bold;">15:00</span> minutes <br> due to high demand';
            messageElement.style.backgroundColor = "#f8f9fa";
            messageElement.style.borderColor = "#e9ecef";
            messageElement.style.color = "#333";
            messageElement.style.animation = "none";
            messageElement.style.fontWeight = "normal";

            updateCountdown();
          }, 60000);
        }
        return;
      }

      const minutes = Math.floor(timeLeft / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      const formattedTime = `${minutes}:${seconds.toString().padStart(2, "0")}`;

      const timerElement = document.getElementById("countdown-timer");
      if (timerElement) {
        timerElement.textContent = formattedTime;
      }
    }

    // Update countdown immediately and then every second
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // Initialize countdown timer when cart is opened
  initCountdownTimer();

  const currentCartResponse = await fetch(window.Shopify.routes.root + "cart.js");
  const currentCart = await currentCartResponse.json();
  validateCartBundleIntegrity(currentCart);

  // Initial hide of non-Shop Pay buttons
  setTimeout(() => {
    hideNonShopPayButtons();
  }, 500);

  // Set up MutationObserver to watch for dynamically added buttons
  const buttonsContainer = document.querySelector(
    "#slidecart-additional-checkout-buttons"
  );
  if (buttonsContainer) {
    const observer = new MutationObserver((mutations) => {
      let shouldHide = false;
      mutations.forEach((mutation) => {
        if (
          mutation.addedNodes.length > 0 ||
          mutation.type === "childList"
        ) {
          shouldHide = true;
        }
      });

      if (shouldHide) {
        console.log("🔄 [Shop Pay] Detected DOM changes, re-hiding buttons...");
        setTimeout(() => {
          hideNonShopPayButtons();
        }, 100);
      }
    });

    observer.observe(buttonsContainer, {
      childList: true,
      subtree: true,
    });

    console.log("👀 [Shop Pay] MutationObserver set up to watch for button changes");
  }

  // Listen for cart update events
  document.addEventListener("cart:updated", () => {
    console.log("🔄 [Shop Pay] Cart updated, hiding non-Shop Pay buttons...");
    setTimeout(() => {
      hideNonShopPayButtons();
    }, 200);
  });

  // Also run when slidecart is opened
  document.addEventListener("slidecart:opened", () => {
    console.log("🔄 [Shop Pay] Slidecart opened, hiding non-Shop Pay buttons...");
    setTimeout(() => {
      hideNonShopPayButtons();
    }, 300);
  });
});
